<template>
  <div>
    <Viewer :options="options" :images="images" class="viewer" ref="viewer">
      <template #default="scope">
        <slot :images="scope.images">
          <img
            :src="src"
            :style="{ width, height }"
            v-for="src in images"
            :key="src"
        /></slot>
      </template>
    </Viewer>
  </div>
</template>

<script>
// 引入图片组件
import "viewerjs/dist/viewer.css";
import { component as Viewer } from "v-viewer";
export default {
  name: "v-image",
  components: {
    Viewer
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    }
  },
  data() {
    return {
      options: {
        title: false,
        // inline: true
      }
    };
  },
  methods: {
    view(index) {
      this.$refs.viewer.$viewer.view(index);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/v_image.vue